<template>
  <div class="container-rules" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k005') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 标题和警告 -->
      <!-- <div class="title">{{ $t('lang.BaseCommon.k005') }}</div> -->
      <div class="text1">{{ $t('lang.BaseRules.k036') }}</div>
      <!-- call规则 -->
      <div class="title">{{ $t('lang.BaseRules.k035') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k022') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k027') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k028') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k029') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k030') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k031') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k032') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k033') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k034') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k023') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k024') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k025') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k026') }}</div>
      <br />
      <!-- chat规则 -->
      <div class="title">{{ $t('lang.BaseRules.k037') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k044') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k038') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k039') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k040') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k041') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k042') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k043') }}</div>
      <br />
      <!-- 账户规则 -->
      <div class="title">{{ $t('lang.BaseRules.k015') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k001') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k016') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k017') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k018') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k019') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k020') }}</div>
      <div class="text1">{{ $t('lang.BaseRules.k021') }}</div>
      <br />
      <!-- 结语 -->
      <div class="text1">{{ $t('lang.BaseRules.k045') }}</div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    return {}
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-nav-block {
  background-color: #f9f9fb;
}
.container-rules {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 20px 16px;
    color: #666666;
    .title {
      color: #000;
      margin-bottom: 12px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-700);
      line-height: var(--lh-body-20);
    }
    .text1 {
      width: 100%;
      color: #333333;
      margin-bottom: 12px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-20);
    }
  }
}
</style>
